import { datadogRum } from '@datadog/browser-rum';

const DD_RUM_SERVICE = 'shop-fe';

function initDatadogRum() {
  const configEl = document.getElementById('datadog-rum-config');
  if (!configEl) {
    return;
  }

  const config = JSON.parse(configEl.getAttribute('data-config'));

  datadogRum.init({
    applicationId: config.application_id,
    clientToken: config.client_token,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: DD_RUM_SERVICE,
    env: config.env,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: config.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend() {
      return Sq.OneTrust.analyticsTrackingEnabled;
    },
  });
}

initDatadogRum();
